import React from 'react'

import { useFiltersContext } from '@contexts/FilterContext'

import styles from './styles.module.css'

const Reset = () => {
  const { filters, resetFilters } = useFiltersContext()

  const areFiltersApplied = Object.values(filters).some(value => (Array.isArray(value) ? value.length > 0 : !!value))

  return (
    <button className={styles.reset} data-filtered={areFiltersApplied} onClick={resetFilters}>
      Reset Filters
    </button>
  )
}

export default Reset
